import { render, staticRenderFns } from "./bs11.vue?vue&type=template&id=02c9cf5c&scoped=true&"
import script from "./bs11.vue?vue&type=script&lang=js&"
export * from "./bs11.vue?vue&type=script&lang=js&"
import style0 from "./bs11.vue?vue&type=style&index=0&id=02c9cf5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c9cf5c",
  null
  
)

export default component.exports